module.exports = __webpack_public_path__ + "media/2.7d75f2a9.mp3";